import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import "../SignIn.css";
import logo from "../imgs/logo.png";
import { LockClosedIcon } from "@heroicons/react/20/solid";
import { useAuth } from "./useAuth";
import axios from "axios";
import url from "./url";
function SignUp() {
  const [first_name, setFirstName] = useState("");
  const [last_name, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  var { login } = useAuth();
  const [errors, setErrors] = useState([]);
  const [spin, setSpin] = useState(false);

  // const navigate = useNavigate();

  const handleSignIn = (event) => {
    setErrorMessage("");
    setErrors([]);
    event.preventDefault(); // prevent page reload
    // alert("hello");
    if (confirmpassword != password) {
      setErrorMessage("Password mitsmatch");

      return;
    }

    setSpin(true);

    axios
      .post(url + "sdk/auth/register", {
        email,
        password,
        first_name,
        last_name,
      })
      .then((res) => {
        console.log("res");
        console.log(res);
        localStorage.setItem("token", res.data.result.accessToken);
        localStorage.setItem("user_id", res.data.result.id);
        localStorage.setItem("status", "true");
        navigate("/scan");
        // alert(res.data.result.id);
      })
      .catch((e) => {
        if (e.response.status == 422) {
          setErrors(e.response.data.result);
        } else {
          setErrorMessage("Error occured");
        }
        // console.log(e.response.status);
        // console.log(e.response.data.result);
      })
      .then((r) => {
        console.log(r);
        setSpin(false);
      });
  };
  const rendererrors = errors.map((error, index) => (
    <li index={index} className="text-red-500 font-extrabold">
      {error}
    </li>
  ));
  return (
    <>
      <div className="flex min-h-full items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md space-y-8">
          <div>
            <img className="mx-auto w-32 h-28" src={logo} alt="Docsun" />
            {/* <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
              Docsun AI SDK
            </h2> */}
            <p className="mt-2 text-center text-lg text-gray-600">
              Non-Contact Vital Health Solutions For All
            </p>
          </div>
          <div>{rendererrors}</div>
          <form className="mt-8 space-y-6" action="#" onSubmit={handleSignIn}>
            <input type="hidden" name="remember" defaultValue="true" />
            <div className="-space-y-px rounded-md shadow-sm">
              <div>
                <label htmlFor="email-address" className="sr-only">
                  First Name
                </label>
                <input
                  id="email-address"
                  name="first_name"
                  type="text"
                  autoComplete="first_name"
                  required
                  value={first_name}
                  onChange={(e) => setFirstName(e.target.value)}
                  className=" my-2 relative block w-full appearance-none  rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="First Name"
                />
              </div>
              <div>
                <label htmlFor="email-address" className="sr-only">
                  Last Name
                </label>
                <input
                  id="email-address"
                  name="last_name"
                  type="text"
                  autoComplete="last_name"
                  required
                  value={last_name}
                  onChange={(e) => setLastName(e.target.value)}
                  className=" my-2relative block w-full appearance-none  rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="Last Name"
                />
              </div>
              <div>
                <label htmlFor="email-address" className="sr-only">
                  Email address
                </label>
                <input
                  id="email-address"
                  name="uname"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="my-2 relative block w-full appearance-none  rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="Email address"
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Password
                </label>
                <input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  id="password"
                  name="pass"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="my-2 relative block w-full appearance-none  rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="Password"
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Confirm Password
                </label>
                <input
                  value={confirmpassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  id="password"
                  name="pass"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="my-2 relative block w-full appearance-none  rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="Confirm Password"
                />
              </div>
            </div>

            <div className="flex items-center justify-between">
              <div className="text-sm"></div>
              <div className="text-sm">
                <Link
                  to="/"
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                >
                  Go to Signin
                </Link>
              </div>
            </div>

            <div className="error__value text-red-500">{errorMessage} </div>
            <div className="error__value text-red-500">
              {spin ? (
                <>
                  <div role="status">
                    <svg
                      aria-hidden="true"
                      class="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                    <span class="sr-only">Loading...</span>
                  </div>
                </>
              ) : null}{" "}
            </div>

            <div>
              <button
                type="submit"
                className="group relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                  <LockClosedIcon
                    className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                    aria-hidden="true"
                  />
                </span>
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default SignUp;
